<ng-container *transloco="let t">
    <div class="space-y-6">
        <div *ngFor="let member of items(); trackByProperty: 'id'">
            <ng-container *ngIf="isCartShared()">
                <p class="font-normal text-slate-700">
                    <span>{{ member.name }}</span>
                    <span *ngIf="member.id === currentUserId()" class="lowercase"> ({{ t('you') }})</span>
                    <span *ngIf="member.is_owner" class="lowercase"> ({{ t('group_owner') }})</span>
                </p>
                <hr class="border-b border-gray-100 h-[1px] my-1" />
            </ng-container>

            <ng-container *ngIf="member.items.length; else emptyCartTitle">
                <div class="grid grid-cols-1 divide-y divide-gray-50">
                    <ng-container *ngFor="let item of member.items; trackByProperty: 'uuid'">
                        <us-order-item
                            [item]="item"
                            [readonly]="readonly || item.user?.id !== currentUserId()"
                            (quantityChanged)="onChangeItemQuantity(item, $event)"
                        ></us-order-item>
                    </ng-container>
                </div>
            </ng-container>

            <ng-container *ngIf="isCartShared()">
                <hr class="border-b border-gray-100 h-[1px] my-1" />
                <div class="flex items-end justify-between">
                    <span class="text-gray-600">
                        {{ t('subtotal') }} ({{ member.total_items + ' ' + ('item' | transloco) }})
                    </span>
                    <span class="text-gray-600"> {{ member.subtotal | formatCurrency }} </span>
                </div>
            </ng-container>
        </div>
    </div>

    <ng-template #emptyCartTitle>
        <ng-container *ngIf="!isCartShared(); else groupBuyEmptyTmpl">
            <us-empty class="mb-4" [title]="t('your_cart_is_empty')"></us-empty>
        </ng-container>

        <ng-template #groupBuyEmptyTmpl>
            <div class="py-4">
                <p class="text-gray-600 text-sm">{{ t('no_items_added_yet') }}</p>
            </div>
        </ng-template>
    </ng-template>
</ng-container>
